/**
 * NEW badge on Shoply search/chat cards (Shadow DOM).
 * Shoply mounts cards inside open shadow roots — document.querySelector misses them.
 */
(function () {
  var NEW_IMG =
    (window.__BT_BADGE_ASSETS__ && window.__BT_BADGE_ASSETS__.newImg) ||
    "/cdn/shop/t/9/assets/bt-new-badge.png";
  var DAY = 86400;
  var byId = null;
  var byHandle = null;
  var loading = null;
  var watched = new WeakSet();
  var BT_TOP_CLASS = "bt-top-badge--shoply";

  function log() {
    if (window.__BT_BADGES_DEBUG__) {
      console.log.apply(console, ["[bt-new-badge]"].concat([].slice.call(arguments)));
    }
  }

  function fiberKey(el) {
    for (var k in el) {
      if (k.indexOf("__reactFiber") === 0 || k.indexOf("__reactInternalInstance") === 0) {
        return k;
      }
    }
    return null;
  }

  function walkFiber(fiber, depth) {
    if (!fiber || depth > 50) return null;
    var props = fiber.memoizedProps || fiber.pendingProps;
    if (props && props.product_info && (props.product_info.product_id || props.product_info.url)) {
      return props.product_info;
    }
    return walkFiber(fiber.child, depth + 1) || walkFiber(fiber.sibling, depth + 1);
  }

  function productInfoFromCard(card) {
    var key = fiberKey(card);
    if (key) {
      var info = walkFiber(card[key], 0);
      if (info) return info;
    }
    var nodes = card.querySelectorAll("*");
    for (var i = 0; i < Math.min(nodes.length, 60); i++) {
      var fk = fiberKey(nodes[i]);
      if (!fk) continue;
      var found = walkFiber(nodes[i][fk], 0);
      if (found) return found;
    }
    return null;
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function coverHost(card) {
    var img =
      card.querySelector("img.shoply-product-image") ||
      card.querySelector("img[id^='image_']") ||
      card.querySelector("img");
    var host =
      (img && (img.closest(".product-image-wrapper") || img.parentElement)) || card;
    host.style.position = "relative";
    host.style.overflow = "visible";
    return host;
  }

  function ensureNew(host) {
    if (!host || host.querySelector(".bt-new-badge")) return;
    var span = document.createElement("span");
    span.className = "bt-new-badge bt-new-badge--shoply";
    span.setAttribute("aria-label", "新登場");
    span.style.cssText =
      "position:absolute;top:6px;right:6px;z-index:50;display:block;width:72px;max-width:42%;line-height:0;pointer-events:none;";
    span.innerHTML =
      '<img src="' +
      NEW_IMG +
      '" alt="NEW 新登場" width="118" height="64" style="display:block;width:100%;height:auto;" loading="lazy">';
    host.appendChild(span);
  }


  // ---- 熱賣 HOT SALE badge (Top1–30 via window.BT_TOP20; art = BT_HOT_SALE_IMG) ----
  // Restored 2026-10-29 fire badge D — single sticker for all ranks
  function topRankById(id) {
    var map = window.BT_TOP20;
    if (!map || id == null) return 0;
    var m = String(id).match(/(\d+)\s*$/); // numeric id or gid://shopify/Product/123
    if (!m) return 0;
    var r = parseInt(map[m[1]], 10);
    return r >= 1 && r <= 30 ? r : 0;
  }

  function removeNew(host, scope) {
    [host, scope].forEach(function (n) {
      if (!n || !n.querySelectorAll) return;
      n.querySelectorAll(".bt-new-badge").forEach(function (e) {
        e.remove();
      });
    });
  }

  function hotSaleSrc() {
    return (
      window.BT_HOT_SALE_IMG ||
      (window.__BT_BADGE_ASSETS__ && window.__BT_BADGE_ASSETS__.hotSaleImg) ||
      ""
    );
  }

  function ensureTop(host, rank, cssText) {
    if (!host || !rank) return;
    var src = hotSaleSrc();
    if (!src) return;
    var old = host.querySelector(".bt-top-badge");
    if (old) {
      if (old.getAttribute("data-rank") === String(rank) && old.getAttribute("data-hot") === "1") return;
      old.remove();
    }
    var span = document.createElement("span");
    span.className = "bt-top-badge " + BT_TOP_CLASS;
    span.setAttribute("data-rank", String(rank));
    span.setAttribute("data-hot", "1");
    span.setAttribute("aria-label", "熱賣 HOT SALE");
    span.style.cssText = cssText;
    span.innerHTML =
      '<img src="' + src + '" alt="熱賣 HOT SALE" width="60" height="60" style="display:block;width:100%;height:auto;" loading="lazy">';
    host.appendChild(span);
  }

  // Relative size vs cover host (14.28% = 16.8×0.85, boss collection −15% 2026-10-29). Same ratio every card size.
  // Inline styles because Shoply lives in a shadow root where base.css does not apply.
  function topCss() {
    return "position:absolute;top:6px;right:6px;z-index:51;display:block;width:14.28%;max-width:14.28%;line-height:0;pointer-events:none;";
  }

  function isNew(product) {
    if (!product) return false;
    var raw = product.created_at || product.published_at;
    if (!raw) return false;
    return Date.now() / 1000 - new Date(raw).getTime() / 1000 < 14 * DAY;
  }

  function loadCatalog() {
    if (byId) return Promise.resolve();
    if (loading) return loading;
    loading = (async function () {
      byId = Object.create(null);
      byHandle = Object.create(null);
      for (var page = 1; page <= 12; page++) {
        var res = await fetch("/products.json?limit=250&page=" + page, {
          credentials: "same-origin",
        });
        if (!res.ok) break;
        var list = ((await res.json()) || {}).products || [];
        if (!list.length) break;
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          byId[String(p.id)] = p;
          byHandle[p.handle] = p;
        }
        if (list.length < 250) break;
      }
      log("catalog", Object.keys(byId).length);
    })().catch(function (e) {
      log("catalog err", e);
      byId = byId || Object.create(null);
      byHandle = byHandle || Object.create(null);
    });
    return loading;
  }

  function resolveProduct(info, card) {
    if (info) {
      var id = info.product_id != null ? String(info.product_id).replace(/^.*\//, "") : "";
      if (id && byId[id]) return byId[id];
      var handle = handleFromUrl(info.url);
      if (handle && byHandle[handle]) return byHandle[handle];
    }
    var el = card.querySelector("[id^='image_']");
    if (el) {
      var m = String(el.id).match(/^image_(?:gid:\/\/shopify\/Product\/)?(\d{6,})/);
      if (m && byId[m[1]]) return byId[m[1]];
    }
    var nameEl = card.querySelector(".shoply-product-name");
    var title = nameEl ? nameEl.textContent.replace(/\s+/g, " ").trim().toLowerCase() : "";
    if (title) {
      for (var pid in byId) {
        var t = String(byId[pid].title || "").toLowerCase();
        if (t === title || t.indexOf(title.slice(0, 18)) === 0 || title.indexOf(t.slice(0, 18)) === 0) {
          return byId[pid];
        }
      }
    }
    return null;
  }

  function fetchByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (byHandle && byHandle[handle]) return Promise.resolve(byHandle[handle]);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function quickTopRank(info, card) {
    var r = 0;
    if (info && info.product_id != null) r = topRankById(info.product_id);
    if (!r) {
      var el = card.querySelector("[id^='image_']");
      if (el) r = topRankById(String(el.id).replace(/^image_/, ""));
    }
    return r;
  }

  function enhance(card) {
    if (!(card instanceof Element)) return;
    if (card.getAttribute("data-bt-new") === "1") return;
    if (card.getAttribute("data-bt-new") === "pending") return;

    card.setAttribute("data-bt-new", "pending");
    loadCatalog().then(function () {
      var info = productInfoFromCard(card);
      log("info", info && { id: info.product_id, url: info.url, name: info.product_name });

      // TOP 20 by product id (numeric or gid) — no catalog needed; TOP replaces NEW.
      var quick = quickTopRank(info, card);
      if (quick) {
        var h = coverHost(card);
        removeNew(h, card);
        ensureTop(h, quick, topCss());
        card.setAttribute("data-bt-new", "1");
        log("top", quick);
        return;
      }

      var product = resolveProduct(info, card);
      var handle = info && handleFromUrl(info.url);

      var done = function (p) {
        var rank = p ? topRankById(p.id) : 0;
        log("product", p && p.handle, "top", rank, "new?", isNew(p));
        if (rank) {
          var h2 = coverHost(card);
          removeNew(h2, card);
          ensureTop(h2, rank, topCss());
        } else if (isNew(p)) {
          ensureNew(coverHost(card));
        }
        card.setAttribute("data-bt-new", "1");
      };

      if (product) return done(product);
      if (handle) return fetchByHandle(handle).then(done);

      log("unresolved");
      card.removeAttribute("data-bt-new");
    });
  }

  function collectShadowRoots() {
    var roots = [];
    // known Shoply hosts
    ["shoply-ai-search", "floating-shopping-assistant"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.shadowRoot) roots.push(el.shadowRoot);
    });
    // any open shadow root under body
    document.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot && roots.indexOf(el.shadowRoot) === -1) roots.push(el.shadowRoot);
    });
    return roots;
  }

  function scanRoot(root) {
    if (!root || !root.querySelectorAll) return 0;
    var list = root.querySelectorAll(".shoply-product-card, .shoply-card");
    list.forEach(enhance);
    return list.length;
  }

  function scanAll() {
    var total = scanRoot(document);
    var shadows = collectShadowRoots();
    shadows.forEach(function (sr) {
      total += scanRoot(sr);
      watchRoot(sr);
    });
    log("scan", total, "shadows", shadows.length);
    return total;
  }

  function watchRoot(root) {
    if (!root || watched.has(root)) return;
    watched.add(root);
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches(".shoply-product-card") || n.matches(".shoply-card"))) {
            enhance(n);
          } else if (n.querySelectorAll) {
            scanRoot(n);
          }
          if (n.shadowRoot) {
            watchRoot(n.shadowRoot);
            scanRoot(n.shadowRoot);
          }
        }
      }
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function start() {
    window.__BT_BADGES_DEBUG__ = true;
    loadCatalog();
    watchRoot(document.documentElement);
    scanAll();
    [800, 2000, 4000, 7000, 10000].forEach(function (ms) {
      setTimeout(scanAll, ms);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
